import { initApp } from 'api/setup';
import AppInit from 'components/AppInit/AppInit';
import React, { useRef } from 'react';
import AuthenticatedProviders from './AuthenticatedProviders';
import MainLayout from './Layout/MainLayout';
import AuthenticatedRoutes from './Router/AuthenticatedRoutes';
import Providers from './Providers';
import AppGlobalStyles from './AppGlobalStyles';

const Main = () => {
	const initRef = useRef(false);
	if (!initRef.current) {
		initApp();
		initRef.current = true;
	}

	return (
		<Providers>
			<AppGlobalStyles />
			<MainLayout>
				<AppInit>
					<AuthenticatedProviders>
						<AuthenticatedRoutes />
					</AuthenticatedProviders>
				</AppInit>
			</MainLayout>
		</Providers>
	);
};

export default Main;
